import { styled } from 'lib/ui';

export const OrderFormRestaurantPickerContainer = styled.div.attrs({
  className: 'OrderFormRestaurantPickerContainer',
})`
  width: 100%;
`;
